import { useFormik } from 'formik';
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { activateRole, deactivateRole, resetRoles, updateRole } from '../../../redux/slice/roles/roleSlice';
import { useNavigate } from 'react-router-dom';
import { getAllRoles } from '../../../redux/slice/staff/staffSlice';


const RoleDetail = ({modal_id, item}) => {
  const { isUpdated, isActivated } = useSelector((state) => state?.role);
   const [isEditing, setIsEditing] = useState(false)
  const [hasEditRole, setHasEditRole] = useState()
  const [hasActivateRole, setHasActivateRole] = useState()
  const [hasDeactivateRole, setHasDeactivateRole] = useState()

  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const close = useRef();
  const form = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const id = item.id

  const onSubmit = (values) => {
    let payload = { ...values,id};
    dispatch(updateRole(payload));
    close.current.click()
  };

    const handleDeactivate = (userId) => {
        dispatch(deactivateRole(userId));
    };

    const handleActivate = (userId) => {
        dispatch(activateRole(userId));
    };

  const validationScehma = Yup.object().shape({
    name: Yup.string("Role Name must be a string").required(
      "Role Name cannot be blank"
    ),
    description: Yup.string("Description must be a string").required(
      "Description cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: item?.name || "",
      description: item?.description || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    if (isUpdated || isActivated) {
        close.current.click()
        dispatch(getAllRoles())
        dispatch(resetRoles())
        return;
    }
  }, [dispatch, isActivated, isUpdated, navigate]);

  useEffect(() => {
    setHasEditRole(user_permissions?.some(permission => permission.name === 'edit role'))
    setHasActivateRole(user_permissions?.some(permission => permission.name === 'activate role'))
    setHasDeactivateRole(user_permissions?.some(permission => permission.name === 'deactivate role'))
}, [user_permissions])
  
  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <form
            className='modal-content rounded-4'
            ref={form}
            onSubmit={handleSubmit}
          >
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                {isEditing ? 'Edit' : 'View'} Role
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  resetForm();
                  setIsEditing(false)
                  form.current.reset();
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>

            <div className='modal-body'>
              <div className='px-3'>
                <div className='row mb-3'>
                  <div className='col-md-4 text-end sm-text-end'>
                    <label
                      htmlFor='username'
                      className={`form-label mt-1  ${
                        errors?.name &&
                        touched?.name &&
                        "text-danger"
                      }`}
                    >
                      Name 
                    </label>
                  </div>
                  <div className='col-md-8'>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      className={`form-control ${
                        errors?.name &&
                        touched?.name &&
                        "is-invalid"
                      }`}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      readOnly={!isEditing}
                    />
                    {errors?.name && touched?.name && (
                      <p className='invalid-feedback mb-0'>
                        {errors?.name}
                      </p>
                    )}
                  </div>
                </div>
                <div className='row'>
                    <div className='col-md-4 text-end sm-text-end'>
                        <label htmlFor='' className={`form-label mt-1  ${errors?.description && touched?.description && "text-danger"}`}>
                            Description
                        </label>
                    </div>
                    <div className='col-md-8'>
                        <textarea
                        id='description'
                        name='description'
                        className={`form-control ${
                            errors?.description &&
                            touched?.description &&
                            "is-invalid"
                          }`}
                        value={values?.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        readOnly={!isEditing}
                        ></textarea>
                        {errors?.description && (
                            <p className='invalid-feedback mb-0'>
                                {errors?.description}
                            </p>
                        )}
                    </div>
                </div>
              </div>
            </div>
            <div className={`modal-footer d-flex ${(!hasActivateRole && !hasDeactivateRole) ? 'justify-content-end' : 'justify-content-between'} mt-4`}>
              <div>
                {item?.active === "1" ?( hasDeactivateRole &&<button
                    type='button'
                    className={`btn btn-warning text-white btn-sm rounded-3`}
                    data-bs-dismiss='modal'
                    onClick={() => handleDeactivate(item.id)}
                >
                  Deactivate
                </button>) : ( hasActivateRole &&<button
                    type='button'
                    className={`btn btn-success text-white btn-sm rounded-3`}
                    data-bs-dismiss='modal'
                    onClick={() => handleActivate(item.id)}
                >
                 Activate
                </button>)}
              </div>
              <div className='me-3 d-flex gap-1'>
                <button
                    type='button'
                    className='btn btn-secondary btn-sm rounded-3'
                    data-bs-dismiss='modal'
                    onClick={() => {
                    resetForm();
                    setIsEditing(false)
                    form.current.reset();
                    }}
                >
                    Close
                </button>
                {/* <button
                    type='button'
                    className='btn btn-danger btn-sm rounded-3'
                    data-bs-dismiss='modal'
                    onClick={() => {
                    resetForm();
                    form.current.reset();
                    }}
                >
                    Delete
                </button> */}
                {hasEditRole && <div>
                  {!isEditing && <button
                      type='button'
                      className='btn btn-primary btn-sm rounded-3'
                      onClick={() => {
                          setIsEditing(true);
                      }}
                  >
                      Edit
                  </button>}
                  {isEditing && <button
                      type='submit'
                      className='btn btn-primary btn-sm rounded-3'
                  >
                      Update
                  </button>}
                </div>}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default RoleDetail